
import React, { useState, useMemo, useEffect } from "react";
import {
  Typography, Box, Grid2 as Grid, Button,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import InfoCard from "../../components/cards/InfoCard";
import TableEmpresas from "../../components/admin/TableEmpresas";
import { getEmpresas, updateEmpresaStatus, deleteEmpresa } from "../../actions/empresas";

const Empresas = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { empresas, loading } = useSelector(state => state.empresas);
  const updatesServices = moment().format("DD MMMM YYYY");

  // Delete Modal State
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [empresaToDelete, setEmpresaToDelete] = useState(null);

  useEffect(() => {
    dispatch(getEmpresas());
  }, [dispatch]);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const stats = useMemo(() => {
    return {
      total: empresas.length,
      active: empresas.filter(e => e.status).length,
    };
  }, [empresas]);


  const statistics = [
    { title: "Total Empresas", value: stats.total, info: "Registradas en la plataforma" },
    { title: "Empresas Activas", value: stats.active, info: "Con operaciones recientes" },
  ];

  const results = useMemo(() => {
    const toSend = empresas.map(e => ({
      id: e._id,
      name: e.razon,
      rfc: e.rfc,
      rfc: e.rfc,
      status: e.status,
      servicios: e.servicios || []
    })) || [];

    if (search === "") return toSend;
    const term = search.toLowerCase().trim();
    return toSend.filter(item =>
      item.name.toLowerCase().includes(term) ||
      item.rfc.toLowerCase().includes(term)
    )
  }, [search, empresas]);

  const handleChangePage = newPage => {
    setPage(newPage);
  };

  const totalPages = Math.ceil(results.length / rowsPerPage);

  const irA = where => {
    // navigate(where); // Placeholder for now
    console.log("Navigating to", where);
  }

  const handleEdit = (empresa) => {
    navigate(`/admin/empresas/editar/${empresa.id}`);
  }

  const handleDelete = (empresa) => {
    setEmpresaToDelete(empresa);
    setOpenDeleteModal(true);
  }

  const confirmDelete = async () => {
    if (empresaToDelete) {
      await dispatch(deleteEmpresa(empresaToDelete.id));
      setOpenDeleteModal(false);
      setEmpresaToDelete(null);
      dispatch(getEmpresas());
    }
  }

  const handleAdd = () => {
    navigate('/admin/empresas/nueva');
  }

  const handleStatusChange = async (empresa) => {
    // Toggle status
    await dispatch(updateEmpresaStatus(empresa.id, !empresa.status));
    // Refresh list
    dispatch(getEmpresas());
  }

  if (loading && empresas.length === 0) {
    return <Typography>Cargando empresas...</Typography>; // Simple loading state
  }

  return (
    <Grid container mt={{ xs: 10, md: 12 }} spacing={2}>
      <Grid size={12}>
        <Typography mt={3} variant="h6" color="primary">
          Panel de administración de empresas
        </Typography>
        <Typography
          variant="body2"
          color="#737791"
          sx={{ marginBottom: 1 }}
        >
          Información actualizada al {updatesServices}
        </Typography>
      </Grid>
      <Grid size={12}>
        <Grid container spacing={2} sx={{ alignItems: "stretch", marginBottom: 2 }}>
          {statistics.map((statistic, index) => (
            <Grid
              key={`statistic${index}`}
              size={{ xs: 12, sm: 6, lg: 3 }}
              sx={{ marginBottom: 2 }}
            >
              <InfoCard item={statistic} handleLink={() => { }} />
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid size={12} container justifyContent="space-between" alignItems="center" mt={3}>
        <Box>
          <Typography variant="h6" color="primary">
            Listado de empresas
          </Typography>
          <Typography
            variant="body2"
            color="#737791"
            sx={{ marginBottom: 1 }}
          >
            Gestiona la información de las empresas registradas
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          sx={{ height: 'fit-content' }}
        >
          Agregar empresa
        </Button>
      </Grid>
      <TableEmpresas
        results={results}
        search={search}
        setSearch={setSearch}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        handleChangePage={handleChangePage}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onStatusChange={handleStatusChange}
      />

      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"¿Estás seguro que quieres eliminar esta empresa?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Se eliminarán todos sus servicios relacionados. Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteModal(false)}>Cancelar</Button>
          <Button onClick={confirmDelete} color="error" variant="contained" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default Empresas;
